module.exports = __webpack_public_path__ + "img/ic_arrow_red.d9c1a081.svg";